const typographyColors = {
  light: '#eef0f2', // primary ink — site is dark throughout, this is the main text color
  dark: '#101113', // for rare inverted (light-surface) contexts only
};

const redColors = {
  light: '#ff4d5e', // gradient end, glow, rating stars
  dark: '#e8142c', // brand accent — vivid red (buttons, active nav, icons)
};

const bgColors = {
  light: '#16181b', // glass panel / card background
  dark: '#101113', // page background (near-black charcoal)
};

const glowColor = 'rgba(232,20,44,0.22)'; // radial accent glow behind hero/CTA
const panelBorder = '1px solid rgba(238,240,242,0.1)'; // hairline border shared by all glass panels/cards
const heroGradient = `linear-gradient(90deg, ${redColors.light}, ${redColors.dark})`; // hero heading text and CTA buttons

export { typographyColors, redColors, bgColors, glowColor, panelBorder, heroGradient };
